"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { ApiProvider, useAuthenticationInformation } from "./api";
import { UserSecurityError, UserSecurityLoading, UserSecurity as UserSecurityPresentational, } from "./lib/user-security";
import { useIsHydrated } from "./lib/use-is-hydrated";
import { useWorkOsApiUrl } from "./lib/widgets-context";
import { ErrorBoundary } from "./lib/error-boundary";
export const UserSecurity = ({ authToken }) => {
    const baseUrl = useWorkOsApiUrl();
    return (_jsx(ApiProvider, { widgetType: "user-security", authToken: authToken, baseUrl: baseUrl, children: _jsx(UserSecurityContent, {}) }));
};
const UserSecurityContent = () => {
    const isHydrated = useIsHydrated();
    const { data: settings, isLoading, isError, isSuccess, error, } = useAuthenticationInformation();
    if (!isHydrated || isLoading) {
        return _jsx(UserSecurityLoading, {});
    }
    if (isError || !isSuccess) {
        return _jsx(UserSecurityError, { error: error });
    }
    return (_jsx(ErrorBoundary, { FallbackComponent: UserSecurityError, children: _jsx(UserSecurityPresentational, { settings: settings.data }) }));
};
//# sourceMappingURL=user-security.client.js.map